import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { priceRegex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { GrUploadOption } from "react-icons/gr";
import { addroom, getroomType } from "../store/slices/roomType";
import { getbedType } from "../store/slices/bedType";
import Select from "react-select";

const AddRooms = () => {
  const { id } = useParams();
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;

  const [roomTypeId, setroomTypeId] = useState("");
  const [bedTypeId, setbedTypeId] = useState("");
  const [totalRoomCount, settotalRoomCount] = useState("");
  const [peopleLimitPerRoom, setpeopleLimitPerRoom] = useState("");
  const [pricePerRoom, setpricePerRoom] = useState("");
  const [availableRoomCount, setavailableRoomCount] = useState("");
  const [extraBedPrice, setextraBedPrice] = useState("");
  const [childrenwithBedPrice, setchildrenwithBedPrice] = useState("");
  const [breakfast, setBreakfast] = useState(false);
  const [lunchOrdinner, setlunchOrdinner] = useState(false);
  const [pricewithBreakfast, setpricewithBreakfast] = useState("");
  const [pricewithDinner, setpricewithDinner] = useState("");
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");
  const [roomSize, setroomSize] = useState("");

  const [roomTypeList, setroomTypeList] = useState([]);
  const [bedtypeList, setbedtypeList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCheckboxChange = (e, checkboxType) => {
    const isChecked = e.target.checked;

    if (checkboxType === "breakfast") {
      setBreakfast(isChecked);

      if (!isChecked) {
        setpricewithBreakfast(""); // Clear price field if unchecked
      }
    }
    if (checkboxType === "lunchOrdinner") {
      setlunchOrdinner(isChecked);

      if (!isChecked) {
        setpricewithDinner(""); // Clear price field if unchecked
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    let sanitizedpricePerRoom = pricePerRoom;
    let sanitizedavailableRoomCount = availableRoomCount;
    let sanitizedtotalRoomCount = totalRoomCount;
    let sanitizedextraBedPrice = extraBedPrice;
    let sanitizedchildrenwithBedPrice = childrenwithBedPrice;
    let sanitizedpeopleLimitPerRoom = peopleLimitPerRoom;
    let sanitizedpricewithBreakfast = pricewithBreakfast;
    let sanitizedpricewithBreakfastandDinner = pricewithDinner;

    switch (name) {
      case "roomTypeId":
        setroomTypeId(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select room type" : "";
        break;

      case "bedTypeId":
        setbedTypeId(value);
        validationErrors[name] =
          value.trim() === "" ? "Please select bed type" : "";
        break;

      case "availableRoomCount":
        sanitizedavailableRoomCount = value.replace(/\D/g, "").slice(0, 3);
        setavailableRoomCount(sanitizedavailableRoomCount);
        validationErrors[name] =
          sanitizedavailableRoomCount === "" ||
          !priceRegex.test(sanitizedavailableRoomCount)
            ? "Please enter valid value"
            : "";
        break;

      case "roomSize":
        sanitizedavailableRoomCount = value.replace(/\D/g, "").slice(0, 3);
        setroomSize(sanitizedavailableRoomCount);
        validationErrors[name] =
          sanitizedavailableRoomCount === "" ||
          !priceRegex.test(sanitizedavailableRoomCount)
            ? "Please enter valid value"
            : "";
        break;

      case "totalRoomCount":
        sanitizedtotalRoomCount = value.replace(/\D/g, "").slice(0, 3);
        settotalRoomCount(sanitizedtotalRoomCount);
        validationErrors[name] =
          sanitizedtotalRoomCount === "" ||
          !priceRegex.test(sanitizedtotalRoomCount)
            ? "Please enter valid value"
            : "";
        break;

      case "peopleLimitPerRoom":
        sanitizedpeopleLimitPerRoom = value.replace(/\D/g, "").slice(0, 1);
        setpeopleLimitPerRoom(sanitizedpeopleLimitPerRoom);
        validationErrors[name] =
          sanitizedpeopleLimitPerRoom === "" ||
          !priceRegex.test(sanitizedpeopleLimitPerRoom)
            ? "Please enter valid value"
            : "";
        break;

      case "pricePerRoom":
        sanitizedpricePerRoom = value.replace(/\D/g, "").slice(0, 7);
        setpricePerRoom(sanitizedpricePerRoom);
        validationErrors[name] =
          sanitizedpricePerRoom === "" ||
          !priceRegex.test(sanitizedpricePerRoom)
            ? "Please enter valid value"
            : "";
        break;

      case "extraBedPrice":
        sanitizedextraBedPrice = value.replace(/\D/g, "").slice(0, 4);
        setextraBedPrice(sanitizedextraBedPrice);
        validationErrors[name] =
          sanitizedextraBedPrice === "" ||
          !priceRegex.test(sanitizedextraBedPrice)
            ? "Please enter valid value"
            : "";
        break;

      case "childrenwithBedPrice":
        sanitizedchildrenwithBedPrice = value.replace(/\D/g, "").slice(0, 4);
        setchildrenwithBedPrice(sanitizedchildrenwithBedPrice);
        validationErrors[name] =
          sanitizedchildrenwithBedPrice === "" ||
          !priceRegex.test(sanitizedchildrenwithBedPrice)
            ? "Please enter valid value"
            : "";
        break;

      case "pricewithBreakfast":
        if (breakfast) {
          sanitizedpricewithBreakfast = value.replace(/\D/g, "").slice(0, 5);
          setpricewithBreakfast(sanitizedpricewithBreakfast);
          validationErrors[name] =
            sanitizedpricewithBreakfast === ""
              ? "Please enter price with breakfast"
              : "";
        } else {
          validationErrors[name] = "";
        }
        break;

      case "pricewithDinner":
        if (lunchOrdinner) {
          sanitizedpricewithBreakfastandDinner = value
            .replace(/\D/g, "")
            .slice(0, 5);
          setpricewithDinner(sanitizedpricewithBreakfastandDinner);
          validationErrors[name] =
            sanitizedpricewithBreakfastandDinner === "" ||
            !priceRegex.test(sanitizedpricewithBreakfastandDinner)
              ? "Please enter valid value"
              : "";
        } else {
          validationErrors[name] = "";
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const scrollToError = () => {
    const firstErrorField = document.querySelector(".is-invalid");
    if (firstErrorField) {
      firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      firstErrorField.focus();
    }
  };

  const validateForm = () => {
    let newErrors = {};
    console.log("Validation Errors: ", newErrors);

    if (!bedTypeId) {
      newErrors.bedTypeId = "Please select a bed type";
    }

    if (!roomTypeId) {
      newErrors.roomTypeId = "Please select room type";
    }

    if (!totalRoomCount.trim()) {
      newErrors.totalRoomCount = "Please enter total no. of rooms";
    } else if (!priceRegex.test(totalRoomCount)) {
      newErrors.totalRoomCount = "Please enter valid value";
    }

    if (!roomSize.trim()) {
      newErrors.roomSize = "Please enter room size";
    } else if (!priceRegex.test(roomSize)) {
      newErrors.roomSize = "Please enter valid value";
    }

    if (!availableRoomCount.trim()) {
      newErrors.availableRoomCount = "Please enter no. of available rooms";
    } else if (!priceRegex.test(availableRoomCount)) {
      newErrors.availableRoomCount = "Please enter valid value";
    }

    if (!peopleLimitPerRoom.trim()) {
      newErrors.peopleLimitPerRoom = "Please enter max occupancy per room";
    } else if (!priceRegex.test(peopleLimitPerRoom)) {
      newErrors.peopleLimitPerRoom = "Please enter valid value";
    }

    if (!extraBedPrice.trim()) {
      newErrors.extraBedPrice = "Please enter extra bed price";
    } else if (!priceRegex.test(extraBedPrice)) {
      newErrors.extraBedPrice = "Please enter valid value";
    }

    if (!pricePerRoom.trim()) {
      newErrors.pricePerRoom = "Please enter room price";
    } else if (!priceRegex.test(pricePerRoom)) {
      newErrors.pricePerRoom = "Please enter valid value";
    }

    if (!childrenwithBedPrice.trim()) {
      newErrors.childrenwithBedPrice = "Please enter child with bed price";
    } else if (!priceRegex.test(childrenwithBedPrice)) {
      newErrors.childrenwithBedPrice = "Please enter valid value";
    }
    if (images.length === 0) {
      newErrors.image = "Please upload at least one image";
      setImageError("Please upload at least one image");
    } else {
      setImageError(""); // Clear the error
    }

    if (breakfast && !pricewithBreakfast.trim()) {
      newErrors.pricewithBreakfast = "Please enter the price with breakfast";
    }

    if (lunchOrdinner && !pricewithDinner.trim()) {
      newErrors.pricewithDinner =
        "Please enter the price with breakfast and dinner";
    }

    setErrors(newErrors);
    const isValid = Object.keys(newErrors).length === 0;
    if (!isValid) {
      scrollToError();
    }
    return isValid;
  };

  const addNewRoom = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      setIsDisabled(false);
      return;
    }
    const hotelId = id;

    const item = {
      roomTypeId,
      bedTypeId,
      roomSize,
      pricePerRoom,
      availableRoomCount,
      childrenwithBedPrice,
      extraBedPrice,
      images: images,
      peopleLimitPerRoom,
      totalRoomCount,
      hotelId,
      ...(breakfast && { breakfast: 1, pricewithBreakfast }),
      ...(lunchOrdinner && { lunchOrdinner: 1, pricewithDinner }),
    };

    try {
      await dispatch(addroom(item)).unwrap();
      alert("Room added successfully!");
      navigate(-1);
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (images.length + files.length > 15) {
      setImageError("You can upload a maximum 15 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImages((prevImage) => [...prevImage, ...newImage]);
    e.target.value = null;
  };

  useEffect(() => {}, [images]);

  const removeImage = (index) => {
    setImages((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const roomTypeData = await dispatch(getroomType()).unwrap();
        const serializedRoomTypeData = roomTypeData?.roomTypeData;
        setroomTypeList(serializedRoomTypeData);

        const bedTypeData = await dispatch(getbedType()).unwrap();
        const serializedBedTypeData = bedTypeData?.bedTypeData;
        setbedtypeList(serializedBedTypeData);
      } catch (err) {
        console.error("Error fetching data:", err.message);
      }
    };
    fetchData();
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Room</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              onClick={cancel}
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Room
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Room</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addNewRoom}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Room Type <span className="text-danger">*</span>
                </label>

                <Select
                  name="roomTypeId"
                  // build react-select options
                  options={roomTypeList.map((catdata) => ({
                    value: catdata._id,
                    label: catdata.name,
                  }))}
                  // set selected value (must be {value,label} object or null)
                  value={
                    roomTypeId
                      ? {
                          value: roomTypeId,
                          label: roomTypeList.find(
                            (opt) => opt._id === roomTypeId,
                          )?.name,
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: "roomTypeId",
                        value: selectedOption ? selectedOption.value : "",
                      },
                    })
                  }
                  placeholder="Select Room Type"
                  classNamePrefix="react-select"
                  className={errors.roomTypeId ? "is-invalid" : ""}
                  isClearable
                />

                {errors.roomTypeId && (
                  <div className="text-danger mt-2">{errors.roomTypeId}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">
                  Bed Type<span className="text-danger">*</span>
                </label>
                <select
                  name="bedTypeId"
                  value={bedTypeId}
                  onChange={handleChange}
                  className={`form-select ${
                    errors.bedTypeId ? "is-invalid" : ""
                  }`}
                >
                  <option value="">Select</option>
                  {bedtypeList?.map((catdata) => (
                    <option key={catdata._id} value={catdata._id}>
                      {catdata.name}
                    </option>
                  ))}
                </select>

                {errors.bedTypeId && (
                  <div className="text-danger mt-2">{errors.bedTypeId}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Room Size
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="roomSize"
                  value={roomSize}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.roomSize ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Room Size"
                />
                {errors.roomSize && (
                  <div className="text-danger mt-2">{errors.roomSize}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Room Price
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="pricePerRoom"
                  value={pricePerRoom}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.pricePerRoom ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Room Price"
                />
                {errors.pricePerRoom && (
                  <div className="text-danger mt-2">{errors.pricePerRoom}</div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Total Rooms
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="totalRoomCount"
                  value={totalRoomCount}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.totalRoomCount ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Total Rooms"
                />
                {errors.totalRoomCount && (
                  <div className="text-danger mt-2">
                    {errors.totalRoomCount}
                  </div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Available Rooms
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="availableRoomCount"
                  value={availableRoomCount}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.availableRoomCount ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Available Rooms"
                />
                {errors.availableRoomCount && (
                  <div className="text-danger mt-2">
                    {errors.availableRoomCount}
                  </div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Extra Bed Price
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="extraBedPrice"
                  value={extraBedPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.extraBedPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Extra Bed Price"
                />
                {errors.extraBedPrice && (
                  <div className="text-danger mt-2">{errors.extraBedPrice}</div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Child Withbed Price (5-12 Years)
                  <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="childrenwithBedPrice"
                  value={childrenwithBedPrice}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.childrenwithBedPrice ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Child With Bed Price"
                />
                {errors.childrenwithBedPrice && (
                  <div className="text-danger mt-2">
                    {errors.childrenwithBedPrice}
                  </div>
                )}
              </div>

              <div className="col-md-5 mt-3">
                <label className="form-label">
                  Max. Occupancy Per Room
                  <span className="text-danger">*</span>
                </label>
                <select
                  name="peopleLimitPerRoom"
                  value={peopleLimitPerRoom}
                  onChange={handleChange}
                  className={`form-select ${
                    errors.peopleLimitPerRoom ? "is-invalid" : ""
                  }`}
                >
                  <option>Select</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                </select>
                {errors.peopleLimitPerRoom && (
                  <div className="text-danger mt-2">
                    {errors.peopleLimitPerRoom}
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 mt-3">
                <div className="form-switch mt-3 switch-purple d-flex align-items-center gap-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="switch4"
                    checked={breakfast}
                    onChange={(e) => handleCheckboxChange(e, "breakfast")}
                  />
                  <label
                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                    htmlFor="switch4"
                  >
                    &nbsp; Breakfast
                  </label>
                </div>
                {breakfast && (
                  <div className="mt-3">
                    <label className="form-label">Price With Breakfast</label>
                    <input
                      type="text"
                      value={pricewithBreakfast}
                      name="pricewithBreakfast"
                      onChange={handleChange}
                      placeholder="Enter Price With Breakfast"
                      className={`form-control ${
                        errors.pricewithBreakfast ? "is-invalid" : ""
                      }`}
                    />
                    {errors.pricewithBreakfast && (
                      <div className="text-danger mt-2">
                        {errors.pricewithBreakfast}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="col-md-5 mt-3">
                <div className="form-switch mt-3 switch-purple d-flex align-items-center gap-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="switch5"
                    checked={lunchOrdinner}
                    onChange={(e) => handleCheckboxChange(e, "lunchOrdinner")}
                  />
                  <label
                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                    htmlFor="switch5"
                  >
                    &nbsp; Lunch/Dinner
                  </label>
                </div>
                {lunchOrdinner && (
                  <div className="mt-3">
                    <label className="form-label">
                      Price With Lunch/Dinner
                    </label>
                    <input
                      type="text"
                      value={pricewithDinner}
                      name="pricewithDinner"
                      onChange={handleChange}
                      placeholder="Enter Price With Lunch/Dinner"
                      className={`form-control ${
                        errors.pricewithDinner ? "is-invalid" : ""
                      }`}
                    />
                    {errors.pricewithDinner && (
                      <div className="text-danger mt-2">
                        {errors.pricewithDinner}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label for="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {images.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddRooms;
